import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "../../styles/header.css";

const listLinks = [
  { name: "HOME", href: "/" },
  { name: "ABOUT", href: "/about" },
  { name: "BLOG", href: "/blog" },
  { name: "CONTACT", href: "/contact" }
];

function HeaderLink({ name, href }) {
  const handleClick = (e) => {
    e.preventDefault();

    window.location.hash = href;

    window.location.reload();
  };

  return (
    <NavLink
      to={href}
      className={({ isActive }) => (isActive ? "active" : "")}
      onClick={handleClick}
    >
      {name}
    </NavLink>
  );
}

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <header className="header">
      <div className="header-container">

        {/* Menu mobile */}
        <div className="header-responsive">
          <ul className={`menu ${isOpen ? "open" : ""}`}>
            {listLinks.map((item) => (
              <HeaderLink key={item.name} {...item} />
            ))}
            <div className="horizontal-line" />
          </ul>

          <div className="header-menu" onClick={toggleMenu}>
            <p>MENU</p>
          </div>
          <div className="horizontal-line" />
        </div>

        {/* Profile */}
        <div className="header-profile-introduction">
          <Link
            to="/"
            onClick={(e) => {
              e.preventDefault();
              window.location.hash = "/";
              window.location.reload();
            }}
          >
            <h1 className="header-name">ION NICULICA</h1>
          </Link>
          <p className="header-description">
          Engineering Student Passionate About Design
          </p>
        </div>

        {/* Menu desktop */}
        <div className="header-filds">
          <ul>
            {listLinks.map((item) => (
              <HeaderLink key={item.name} {...item} />
            ))}
          </ul>
        </div>

      </div>
      <div className="horizontal-line" />
    </header>
  );
}

export default Header;